export default 'Obrigada e até a próxima entrega!';
